import FareGroup from './components/FareGroup/FareGroup';
import DesktopFlightRouteModal from './components/DesktopFlightRouteModal/DesktopFlightRouteModal';
import SpecialEqupmentBaggageCard from './components/Baggage/SpecialEqupment/BaggageCard';
import OrderInsuranceBlockSlotUpsale from '@websky/core/src/Checkout/components/Checkout/OrderInsuranceBlockSlot/OrderInsuranceBlockSlot.upsale';
import CheckoutServicesV2 from '@websky/core/src/Checkout/components/Checkout/ServicesV2/ServicesV2';
import CheckinServicesV2 from '@websky/core/src/Modules/Checkin/components/Checkin/AdditionalServices/AdditionalServices';
export const renders = {
    FareGroupGrid: FareGroup,
    DesktopFlightRouteModal,
    Baggage: {
        SpecialEqupment: {
            BaggageCard: SpecialEqupmentBaggageCard
        }
    },
    CheckoutInsurance: OrderInsuranceBlockSlotUpsale,
    CheckoutServices: CheckoutServicesV2,
    CheckinServices: CheckinServicesV2
};
